export const setLocale = locale => locale
